import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_ADDNOTETOAPPLICATION_FULFILLED = "FETCH_ADDNOTETOAPPLICATION_FULFILLED";
export const FETCH_ADDNOTETOAPPLICATION_REJECTED = "FETCH_ADDNOTETOAPPLICATION_REJECTED";
export const FETCH_ADDNOTETOAPPLICATION_PENDING = "FETCH_ADDNOTETOAPPLICATION_PENDING";
export const RESET_ADDNOTETOAPPLICATION = "RESET_ADDNOTETOAPPLICATION"

export function addNoteToApplication(applicationId, note) {
    const token = localStorage.getItem("accessToken");

    return (dispatch) => {
        dispatch({
            type: "FETCH_ADDNOTETOAPPLICATION",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v3/second-opinion/add-note-to-application`,
                data: { applicationId, note },
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetAddNoteToApplication() {
    return (dispatch) => {
        dispatch({
            type: "RESET_ADDNOTETOAPPLICATION",
        });
    };
}




